import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-session-expired',
  templateUrl: './session-expired.component.html',
  styleUrls: ['./session-expired.component.scss'],
  standalone: false
})
export class SessionExpiredComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}
  connection: string;
  ngOnInit(): void {
    this.connection = this.route.snapshot.queryParams['connection'];
  }
}
